import { render } from "./ProfileMentions.vue?vue&type=template&id=10bf75a2&scoped=true"
const script = {}

import "./ProfileMentions.vue?vue&type=style&index=0&id=10bf75a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bf75a2"]])

export default __exports__